module.exports = __webpack_public_path__ + "static/img/wx-7.d3f1184.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wx-7.png
// module id = PCGj
// module chunks = 10